import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: theme.typography.pxToRem(22),
  height: theme.typography.pxToRem(31),
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out, filter 0.2s ease-in-out',

  '& .GMPin': {
    width: '100%',
    height: '100%',
  },

  '& .GMNumber': {
    fontSize: theme.typography.pxToRem(8),
    lineHeight: 1,
    position: 'absolute',
    top: theme.typography.pxToRem(8),
    margin: 0,
    padding: 0,
    fontWeight: 700,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: theme.palette.common.black,
    userSelect: 'none',
    display: 'none',
  },

  '&:hover': {
    transform: 'scale(1.25)',
    zIndex: 50,
    filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.4))',
    '& .GMNumber': { display: 'block' },
  },

  '&.GMSelected': {
    transform: 'scale(1.25)',
    zIndex: 50,
    filter: 'drop-shadow(0px 2px 6px rgba(0,0,0,0.5))',
    '& .GMNumber': { display: 'block' },
  },

  // Applied when a "Search this area" request is in-flight (disabled=true).
  // Fades the pin to 50% opacity and removes pointer-events so that users
  // cannot accidentally select a vehicle that may disappear once new results load.
  '&.GMDisabled': {
    opacity: 0.5,
    pointerEvents: 'none',
    cursor: 'not-allowed',
  },
}));

export default StyledBox;
